/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import './AkademisyenTopluEkle.css';
import { API_ENDPOINTS } from '../config/api';
import API_BASE_URL from '../config/api';
import { getSelectedYear } from '../config/academicYear';






const AkademisyenTopluEkle = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);

  const [isDragOver, setIsDragOver] = useState(false);
  const [showAssignCourse, setShowAssignCourse] = useState({});
  const [faculties, setFaculties] = useState([]);
  const [programs, setPrograms] = useState({});
  const [courses, setCourses] = useState({});
  const [selectedAssign, setSelectedAssign] = useState({});
  const [assignedCourses, setAssignedCourses] = useState({});
  const [educationTypes, setEducationTypes] = useState([]);
  // Seçmeli ders grubu modal state'leri
  const [showElectiveModal, setShowElectiveModal] = useState({}); // { [akademisyenId]: true/false }
  const [selectedElectiveGroup, setSelectedElectiveGroup] = useState({}); // { [akademisyenId]: course }
  const [electiveLessons, setElectiveLessons] = useState({}); // { [akademisyenId]: [lessons] }
  const [selectedElectiveLessons, setSelectedElectiveLessons] = useState({}); // { [akademisyenId]: [lessonId1, lessonId2, ...] }
  const [search, setSearch] = useState("");
  const [showCourses, setShowCourses] = useState({});
  const [showInactiveSection, setShowInactiveSection] = useState(false);
  const [inactiveAkademisyenler, setInactiveAkademisyenler] = useState([]);
  const [activeAkademisyenler, setActiveAkademisyenler] = useState([]);
  // Excel yükleme bölümü için göster/gizle (varsayılan kapalı)
  const [showExcelSection, setShowExcelSection] = useState(false);
  // Öntest modülü yetkisi
  const [pretestEnabled, setPretestEnabled] = useState(true);
  const [pretestLoading, setPretestLoading] = useState(false);
  
  // Öğrenme çıktıları düzenleme yetkisi
  const [learningOutcomesEditEnabled, setLearningOutcomesEditEnabled] = useState(true);
  const [learningOutcomesEditLoading, setLearningOutcomesEditLoading] = useState(false);

  // İzlence yükleme yetkisi
  const [syllabusUploadEnabled, setSyllabusUploadEnabled] = useState(true);
  const [syllabusUploadLoading, setSyllabusUploadLoading] = useState(false);
  
  // Tek akademisyen ekleme formu için state'ler
  const [singleAkademisyen, setSingleAkademisyen] = useState({
    academician: '',
    staff_status: '',
    facultyId: '',
    programId: '',
    email: ''
  });
  const [singlePrograms, setSinglePrograms] = useState([]);
  const [isAddingSingle, setIsAddingSingle] = useState(false);
  const [singleAddResult, setSingleAddResult] = useState(null);
  const [showSingleForm, setShowSingleForm] = useState(false);
  const [showEmailSuggestion, setShowEmailSuggestion] = useState(false);
  const [showAkademisyenEkle, setShowAkademisyenEkle] = useState(false);
  const [listTab, setListTab] = useState('active'); // 'active' | 'inactive'
  
  // İzlence yetkisi için state'ler
  const [bulkPermissionLoading, setBulkPermissionLoading] = useState(false);
  const allActiveHaveSyllabusPermission = useMemo(
    () => activeAkademisyenler.length > 0 && activeAkademisyenler.every(ak => !!ak.syllabus_permission),
    [activeAkademisyenler]
  );

  // Eğitim türlerini yükle
  useEffect(() => {
    // Sayfa açıldığında tek akademisyen ekleme formu kapalı başlasın
    setShowSingleForm(false);
    const fetchEducationTypes = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.EDUCATION_TYPES);
        setEducationTypes(response.data);
      } catch (error) {
        console.error('Eğitim türleri yüklenirken hata:', error);
      }
    };
    fetchEducationTypes();
  }, []);

  const fetchFaculties = async (educationTypeId) => {
    try {
      const response = await axios.get(`${API_ENDPOINTS.FACULTIES}?educationTypeId=${educationTypeId}`);
      setFaculties(response.data);
    } catch (error) {
      console.error('Fakülteler yüklenirken hata:', error);
      setFaculties([]);
    }
  };

  useEffect(() => {
    loadAkademisyenler();
    axios.get(API_ENDPOINTS.FACULTIES)
      .then(res => setFaculties(res.data))
      .catch(() => setFaculties([]));
    axios.get(API_ENDPOINTS.EDUCATION_TYPES)
      .then(res => setEducationTypes(res.data))
      .catch(() => setEducationTypes([]));
    // Pretest flag
    const fetchPretestFlag = async () => {
      try {
        const res = await fetch(API_ENDPOINTS.PRETEST_PERMISSION);
        const data = await res.json();
        if (data?.success) setPretestEnabled(data.enabled !== false);
      } catch (e) {
        console.error('Pretest flag alınamadı:', e);
      }
    };
    
    // Öğrenme çıktıları düzenleme yetkisi flag
    const fetchLearningOutcomesEditFlag = async () => {
      try {
        const res = await fetch(API_ENDPOINTS.LEARNING_OUTCOMES_EDIT_PERMISSION);
        const data = await res.json();
        if (data?.success) setLearningOutcomesEditEnabled(data.enabled !== false);
      } catch (e) {
        console.error('Öğrenme çıktıları düzenleme yetkisi flag alınamadı:', e);
      }
    };
    
    // İzlence yükleme yetkisi flag
    const fetchSyllabusUploadFlag = async () => {
      try {
        const res = await fetch(API_ENDPOINTS.SYLLABUS_UPLOAD_PERMISSION);
        const data = await res.json();
        if (data?.success) setSyllabusUploadEnabled(data.enabled !== false);
      } catch (e) {
        console.error('İzlence yükleme yetkisi flag alınamadı:', e);
      }
    };

    fetchPretestFlag();
    fetchLearningOutcomesEditFlag();
    fetchSyllabusUploadFlag();
  }, []);

  const loadAkademisyenler = async () => {
    try {
      const [akademisyenRes, permissionsRes] = await Promise.all([
        axios.get(API_ENDPOINTS.AKADEMISYEN_GUNCEL),
        axios.get(`${API_BASE_URL}/api/admin/academic-syllabus-permissions`)
      ]);
      const allAkademisyenler = akademisyenRes.data;
      const permissionMap = permissionsRes.data?.permissions || {};
      
      // Her akademisyenin izlence yetkisini toplu map'ten oku (fallback: false)
      const akademisyenlerWithPermissions = allAkademisyenler.map((akademisyen) => ({
        ...akademisyen,
        syllabus_permission: !!permissionMap[akademisyen.id]
      }));
      
      // Aktif ve pasif akademisyenleri ayır
      const aktifler = akademisyenlerWithPermissions.filter(ak => ak.active !== false);
      const pasifler = akademisyenlerWithPermissions.filter(ak => ak.active === false);
      
      setActiveAkademisyenler(aktifler);
      setInactiveAkademisyenler(pasifler);
      // Atanan dersleri ihtiyaç halinde yüklemek için temizle
      setAssignedCourses({});
    } catch (error) {
      console.error('Akademisyenler yüklenirken hata:', error);
    }
  };

  // Atanan dersleri yalnızca ihtiyaç duyulduğunda getir
  const fetchAssignedCourses = async (akademisyenId) => {
    try {
      const response = await axios.get(API_ENDPOINTS.AKADEMISYEN_ASSIGNED_COURSES_DETAILED(akademisyenId));
      if (response.data?.success) {
        const mappedCourses = (response.data.courses || []).map((course) => ({
          assignmentId: course.id,
          facultyId: course.facultyId,
          programId: course.programId,
          courseId: course.courseId,
          facultyName: course.facultyName,
          programName: course.programName,
          courseName: course.courseName || course.courseCode || ''
        }));
        setAssignedCourses(prev => ({ ...prev, [akademisyenId]: mappedCourses }));
      } else {
        setAssignedCourses(prev => ({ ...prev, [akademisyenId]: [] }));
      }
    } catch (error) {
      console.error(`${akademisyenId} için atanmış dersler alınırken hata:`, error);
      setAssignedCourses(prev => ({ ...prev, [akademisyenId]: [] }));
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && /\.(xlsx|xls|csv)$/i.test(file.name)) {
      setSelectedFile(file);
      setUploadResult(null);
    } else {
      alert('Lütfen geçerli bir .xlsx, .xls veya .csv dosyası seçin.');
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (/\.(xlsx|xls|csv)$/i.test(file.name)) {
        setSelectedFile(file);
        setUploadResult(null);
      } else {
        alert('Lütfen geçerli bir .xlsx, .xls veya .csv dosyası seçin.');
      }
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert('Lütfen bir dosya seçin.');
      return;
    }

    const selectedYear = getSelectedYear();
    if (!selectedYear) {
      alert('Akademisyenlerin yükleneceği akademik yılı üst menüden seçin.');
      return;
    }
    if (!window.confirm(
      `${selectedYear} akademisyen listesi yüklenecek. Bu dosyada bulunmayan ` +
      'kişiler yalnızca seçili yıl için pasif görünecek; geçmiş yıllar ve kullanıcı hesapları silinmeyecek. Devam edilsin mi?'
    )) return;

    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await axios.post(`${API_BASE_URL}/api/akademisyen/upload-excel`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Academic-Year': selectedYear,
        },
      });

      setUploadResult(response.data);
      if (response.data.success) {
        setSelectedFile(null);
        loadAkademisyenler(); // Listeyi yenile
      }
    } catch (error) {
      setUploadResult({
        success: false,
        error: error.response?.data?.error || 'Dosya yüklenirken hata oluştu.'
      });
    } finally {
      setIsUploading(false);
    }
  };

  const downloadTemplate = () => {
    // Excel şablonu oluştur ve indir
    const templateData = [
      ['Ünvanı', 'Adı', 'Soyadı', 'TC Kimlik No', 'Kadro Durumu', 'Birimi', 'Alt Birimi', 'Email'],
      ['Prof.Dr.', 'Hilal Nur', 'Tınas', '', 'Üniversite Kadrosunda', 'Tıp Fakültesi', 'Tıp', 'hilalnur.tinas@kocaelisaglik.edu.tr'],
      ['Dr. Öğr. Üyesi', 'Ahmet', 'Yılmaz', '', 'Üniversite Kadrosunda', 'Mühendislik Fakültesi', 'Bilgisayar Mühendisliği', 'ahmet.yilmaz@kocaelisaglik.edu.tr'],
      ['Öğr.Gör.', 'Ayşe', 'Demir', '', 'Kadro Dışında', 'Sağlık Bilimleri Fakültesi', 'Hemşirelik', 'ayse.demir@kocaelisaglik.edu.tr'],
    ];

    let csvContent = "data:text/csv;charset=utf-8,";
    templateData.forEach(row => {
      csvContent += row.join(",") + "\r\n";
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "akademisyen_sablonu.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchPrograms = async (facultyId) => {
    if (!facultyId) return;
    if (programs[facultyId]) return;
    const res = await axios.get(`${API_ENDPOINTS.PROGRAMS}?facultyId=${facultyId}`);
    setPrograms(prev => ({...prev, [facultyId]: res.data}));
  };

  const fetchCourses = async (programId) => {
    if (!programId) return;
    if (courses[programId]) return;
    const res = await axios.get(`${API_ENDPOINTS.COURSES}?programId=${programId}`);
    setCourses(prev => ({...prev, [programId]: res.data}));
  };

  const fetchElectiveLessons = async (akademisyenId, programId, groupId) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/programs/${programId}/elective-groups/${groupId}/lessons`);
      setElectiveLessons(prev => ({...prev, [akademisyenId]: res.data}));
      // Seçili dersleri sıfırla
      setSelectedElectiveLessons(prev => ({...prev, [akademisyenId]: []}));
    } catch (error) {
      console.error('Alt dersler yüklenirken hata:', error);
      alert('Alt dersler yüklenirken bir hata oluştu.');
      setElectiveLessons(prev => ({...prev, [akademisyenId]: []}));
    }
  };

  const handleShowAssign = (akademisyenId) => {
    setShowAssignCourse(prev => ({...prev, [akademisyenId]: !prev[akademisyenId]}));
  };

  const handleAssignChange = (akademisyenId, field, value) => {
    setSelectedAssign(prev => {
      const updated = {...(prev[akademisyenId] || {})};
      updated[field] = value;
      if (field === 'educationTypeId') {
        updated.facultyId = '';
        updated.programId = '';
        updated.courseId = '';
        // Eğitim türü seçildiğinde fakülte listesini yükle
        if (value) {
          fetchFaculties(value);
        } else {
          setFaculties([]);
        }
      }
      if (field === 'facultyId') {
        updated.programId = '';
        updated.courseId = '';
        fetchPrograms(value);
      }
      if (field === 'programId') {
        updated.courseId = '';
        fetchCourses(value);
      }
      if (field === 'courseId') {
        const selectedCourse = courses[updated.programId]?.find(c => c.id === parseInt(value));
        
        // Seçmeli ders grubu kontrolü
        if (selectedCourse && 
            selectedCourse.courseType === 'Seçmeli' && 
            selectedCourse.name && 
            selectedCourse.name.toUpperCase().includes('SEÇMELİ DERS')) {
          // Modal aç ve alt dersleri getir
          setSelectedElectiveGroup(prev => ({...prev, [akademisyenId]: selectedCourse}));
          fetchElectiveLessons(akademisyenId, updated.programId, value);
          setShowElectiveModal(prev => ({...prev, [akademisyenId]: true}));
          // courseId'yi şimdilik set etme, modal onaylandığında set edilecek
          updated.courseId = value; // Grup ID'sini kaydet
        } else {
          // Normal ders seçimi
          updated.courseId = value;
        }
      }
      return {...prev, [akademisyenId]: updated};
    });
  };

  const handleElectiveLessonToggle = (akademisyenId, lessonId) => {
    setSelectedElectiveLessons(prev => {
      const current = prev[akademisyenId] || [];
      if (current.includes(lessonId)) {
        return {...prev, [akademisyenId]: current.filter(id => id !== lessonId)};
      } else {
        return {...prev, [akademisyenId]: [...current, lessonId]};
      }
    });
  };

  const handleElectiveModalCancel = (akademisyenId) => {
    setShowElectiveModal(prev => ({...prev, [akademisyenId]: false}));
    setSelectedElectiveGroup(prev => {
      const updated = {...prev};
      delete updated[akademisyenId];
      return updated;
    });
    setElectiveLessons(prev => {
      const updated = {...prev};
      delete updated[akademisyenId];
      return updated;
    });
    setSelectedElectiveLessons(prev => {
      const updated = {...prev};
      delete updated[akademisyenId];
      return updated;
    });
    // courseId seçimini sıfırla
    setSelectedAssign(prev => {
      const updated = {...(prev[akademisyenId] || {})};
      updated.courseId = '';
      return {...prev, [akademisyenId]: updated};
    });
  };

  const handleElectiveModalConfirm = async (akademisyenId) => {
    const sel = selectedAssign[akademisyenId];
    const group = selectedElectiveGroup[akademisyenId];
    const selectedLessons = selectedElectiveLessons[akademisyenId] || [];
    
    if (!sel || !sel.educationTypeId || !sel.facultyId || !sel.programId || !sel.courseId || !group) {
      alert('Lütfen tüm bilgileri doldurunuz.');
      return;
    }

    try {
      // Önce seçmeli ders grubunu ata
      const groupRes = await axios.post(API_ENDPOINTS.AKADEMISYEN_ASSIGN_COURSE, {
        akademisyen_id: akademisyenId,
        education_type_id: sel.educationTypeId,
        faculty_id: sel.facultyId,
        program_id: sel.programId,
        course_id: sel.courseId // Grup ID'si
      });

      if (!groupRes.data.success) {
        alert('Seçmeli ders grubu atama başarısız: ' + (groupRes.data.error || 'Bilinmeyen hata'));
        return;
      }

      const facultyObj = faculties.find(f => f.id === parseInt(sel.facultyId));
      const programObj = (programs[sel.facultyId] || []).find(p => p.id === parseInt(sel.programId));

      // Grup atamasını state'e ekle
      setAssignedCourses(prev => ({
        ...prev,
        [akademisyenId]: [...(prev[akademisyenId] || []), {
          assignmentId: groupRes.data.id,
          educationTypeId: sel.educationTypeId,
          facultyId: sel.facultyId,
          programId: sel.programId,
          courseId: sel.courseId,
          facultyName: facultyObj ? facultyObj.name : '',
          programName: programObj ? programObj.name : '',
          courseName: group.name || group.course_name || ''
        }]
      }));

      // Seçilen alt dersleri ata
      const lessonPromises = selectedLessons.map(lessonId => {
        return axios.post(API_ENDPOINTS.AKADEMISYEN_ASSIGN_COURSE, {
          akademisyen_id: akademisyenId,
          education_type_id: sel.educationTypeId,
          faculty_id: sel.facultyId,
          program_id: sel.programId,
          course_id: lessonId // elective_lessons.id
        });
      });

      const lessonResults = await Promise.all(lessonPromises);
      
      // Başarılı atamaları state'e ekle
      const lessons = electiveLessons[akademisyenId] || [];
      lessonResults.forEach((res, index) => {
        if (res.data.success) {
          const lessonId = selectedLessons[index];
          const lesson = lessons.find(l => l.id === lessonId);
          if (lesson) {
            setAssignedCourses(prev => ({
              ...prev,
              [akademisyenId]: [...(prev[akademisyenId] || []), {
                assignmentId: res.data.id,
                educationTypeId: sel.educationTypeId,
                facultyId: sel.facultyId,
                programId: sel.programId,
                courseId: lessonId,
                facultyName: facultyObj ? facultyObj.name : '',
                programName: programObj ? programObj.name : '',
                courseName: lesson.course_name || ''
              }]
            }));
          }
        }
      });

      // State'leri temizle
      setSelectedAssign(prev => ({...prev, [akademisyenId]: {educationTypeId: '', facultyId: '', programId: '', courseId: ''}}));
      handleElectiveModalCancel(akademisyenId);
      
      alert(`Seçmeli ders grubu ve ${selectedLessons.length} adet alt ders başarıyla atandı.`);
    } catch (err) {
      console.error('Ders atama hatası:', err);
      alert('Ders atama sırasında hata oluştu: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleAssignCourse = async (akademisyenId) => {
    const sel = selectedAssign[akademisyenId];
    if (!sel || !sel.educationTypeId || !sel.facultyId || !sel.programId || !sel.courseId) {
      alert('Lütfen eğitim türü, fakülte, program ve ders seçiniz.');
      return;
    }
    
    // Eğer seçmeli ders grubu ise ve modal açık değilse, normal atama yap
    const selectedCourse = courses[sel.programId]?.find(c => c.id === parseInt(sel.courseId));
    const isElectiveGroup = selectedCourse && 
                            selectedCourse.courseType === 'Seçmeli' && 
                            selectedCourse.name && 
                            selectedCourse.name.toUpperCase().includes('SEÇMELİ DERS');
    
    if (isElectiveGroup && !showElectiveModal[akademisyenId]) {
      // Modal açık değilse, modal'ı aç
      setSelectedElectiveGroup(prev => ({...prev, [akademisyenId]: selectedCourse}));
      fetchElectiveLessons(akademisyenId, sel.programId, sel.courseId);
      setShowElectiveModal(prev => ({...prev, [akademisyenId]: true}));
      return;
    }
    
    try {
      const res = await axios.post(API_ENDPOINTS.AKADEMISYEN_ASSIGN_COURSE, {
        akademisyen_id: akademisyenId,
        education_type_id: sel.educationTypeId,
        faculty_id: sel.facultyId,
        program_id: sel.programId,
        course_id: sel.courseId
      });
      if (res.data.success) {
        const courseObj = (courses[sel.programId] || []).find(c => c.id === parseInt(sel.courseId));
        const facultyObj = faculties.find(f => f.id === parseInt(sel.facultyId));
        const programObj = (programs[sel.facultyId] || []).find(p => p.id === parseInt(sel.programId));
        setAssignedCourses(prev => ({
          ...prev,
          [akademisyenId]: [...(prev[akademisyenId] || []), {
            assignmentId: res.data.id,
            educationTypeId: sel.educationTypeId,
            facultyId: sel.facultyId,
            programId: sel.programId,
            courseId: sel.courseId,
            facultyName: facultyObj ? facultyObj.name : '',
            programName: programObj ? programObj.name : '',
            courseName: courseObj ? courseObj.name : ''
          }]
        }));
        setSelectedAssign(prev => ({...prev, [akademisyenId]: {educationTypeId: '', facultyId: '', programId: '', courseId: ''}}));
      } else {
        alert('Ders atama başarısız: ' + (res.data.error || 'Bilinmeyen hata'));
      }
    } catch (err) {
      alert('Ders atama sırasında hata oluştu.');
    }
  };

  const handleRemoveCourse = async (akademisyenId, assignmentId, courseName) => {
    if (window.confirm(`"${courseName}" dersini kaldırmak istediğinizden emin misiniz?`)) {
      try {
        const res = await axios.post(API_ENDPOINTS.AKADEMISYEN_REMOVE_COURSE, {
          assignment_id: assignmentId
        });
        
        if (res.data.success) {
          // State'den dersi kaldır
          setAssignedCourses(prev => ({
            ...prev,
            [akademisyenId]: (prev[akademisyenId] || []).filter(course => course.assignmentId !== assignmentId)
          }));
          alert('Ders ataması başarıyla kaldırıldı!');
        } else {
          alert('Ders kaldırma başarısız: ' + (res.data.error || 'Bilinmeyen hata'));
        }
      } catch (err) {
        alert('Ders kaldırma sırasında hata oluştu.');
        console.error('Ders kaldırma hatası:', err);
      }
    }
  };

  const handleYetkiChange = async (akademisyenId, currentYetki) => {
    try {
      // İzlence yetkisi için yeni API endpoint'i kullan
      const response = await axios.post(`${API_BASE_URL}/api/admin/academic-syllabus-permission/${akademisyenId}`, {
        has_permission: !currentYetki
      });
      
      if (response.data.success) {
        // Sadece bu akademisyenin durumunu güncelle
        setActiveAkademisyenler(prev => 
          prev.map(ak => 
            ak.id === akademisyenId 
              ? { ...ak, syllabus_permission: !currentYetki }
              : ak
          )
        );
        alert(response.data.message);
      } else {
        alert('Yetki güncellenirken hata oluştu: ' + response.data.error);
      }
    } catch (err) {
      console.error('Yetki güncelleme hatası:', err);
      alert('Yetki güncellenirken hata oluştu!');
    }
  };

  // Toplu izlence yetkisi verme/alma fonksiyonları
  const handleBulkGrantSyllabusPermission = async () => {
    if (!window.confirm('Tüm aktif akademisyenlere izlence yetkisi vermek istediğinizden emin misiniz?')) {
      return;
    }
    
    setBulkPermissionLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/admin/bulk-grant-syllabus-permission`);
      if (response.data.success) {
        // Tüm aktif akademisyenlerin yetkisini true yap
        setActiveAkademisyenler(prev => 
          prev.map(ak => ({ ...ak, syllabus_permission: true }))
        );
        alert(response.data.message);
      } else {
        alert('Yetki verilirken hata oluştu: ' + response.data.error);
      }
    } catch (err) {
      console.error('Toplu yetki verme hatası:', err);
      alert('Yetki verilirken hata oluştu!');
    } finally {
      setBulkPermissionLoading(false);
    }
  };

  const handleBulkRevokeSyllabusPermission = async () => {
    if (!window.confirm('Tüm aktif akademisyenlerden izlence yetkisini geri almak istediğinizden emin misiniz?')) {
      return;
    }
    
    setBulkPermissionLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/api/admin/bulk-revoke-syllabus-permission`);
      if (response.data.success) {
        // Tüm aktif akademisyenlerin yetkisini false yap
        setActiveAkademisyenler(prev => 
          prev.map(ak => ({ ...ak, syllabus_permission: false }))
        );
        alert(response.data.message);
      } else {
        alert('Yetki geri alınırken hata oluştu: ' + response.data.error);
      }
    } catch (err) {
      console.error('Toplu yetki geri alma hatası:', err);
      alert('Yetki geri alınırken hata oluştu!');
    } finally {
      setBulkPermissionLoading(false);
    }
  };

  const handleToggleBulkSyllabusPermission = () => {
    if (bulkPermissionLoading) return;
    if (allActiveHaveSyllabusPermission) {
      handleBulkRevokeSyllabusPermission();
    } else {
      handleBulkGrantSyllabusPermission();
    }
  };

  const handleTogglePretestPermission = async () => {
    if (pretestLoading) return;
    setPretestLoading(true);
    const next = !pretestEnabled;
    try {
      const res = await fetch(API_ENDPOINTS.PRETEST_PERMISSION, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled: next })
      });
      const data = await res.json();
      if (data?.success) {
        setPretestEnabled(next);
        alert(next ? 'Öntest modülü açıldı' : 'Öntest modülü kapatıldı');
      } else {
        alert(data?.error || 'Öntest modülü güncellenemedi');
      }
    } catch (e) {
      alert('Sunucu hatası: Öntest modülü güncellenemedi');
    } finally {
      setPretestLoading(false);
    }
  };

  const handleToggleSyllabusUploadPermission = async () => {
    if (syllabusUploadLoading) return;
    setSyllabusUploadLoading(true);
    const next = !syllabusUploadEnabled;
    try {
      const res = await fetch(API_ENDPOINTS.SYLLABUS_UPLOAD_PERMISSION, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled: next })
      });
      const data = await res.json();
      if (data?.success) {
        setSyllabusUploadEnabled(next);
        alert(next ? 'İzlence yükleme yetkisi açıldı' : 'İzlence yükleme yetkisi kapatıldı');
      } else {
        alert(data?.error || 'İzlence yükleme yetkisi güncellenemedi');
      }
    } catch (e) {
      alert('Sunucu hatası: İzlence yükleme yetkisi güncellenemedi');
    } finally {
      setSyllabusUploadLoading(false);
    }
  };

  const handleToggleLearningOutcomesEditPermission = async () => {
    if (learningOutcomesEditLoading) return;
    setLearningOutcomesEditLoading(true);
    const next = !learningOutcomesEditEnabled;
    try {
      const res = await fetch(API_ENDPOINTS.LEARNING_OUTCOMES_EDIT_PERMISSION, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled: next })
      });
      const data = await res.json();
      if (data?.success) {
        setLearningOutcomesEditEnabled(next);
        alert(next ? 'Öğrenme çıktıları düzenleme yetkisi açıldı' : 'Öğrenme çıktıları düzenleme yetkisi kapatıldı');
      } else {
        alert(data?.error || 'Öğrenme çıktıları düzenleme yetkisi güncellenemedi');
      }
    } catch (e) {
      alert('Sunucu hatası: Öğrenme çıktıları düzenleme yetkisi güncellenemedi');
    } finally {
      setLearningOutcomesEditLoading(false);
    }
  };

  const handleShowCourses = (akademisyenId) => {
    setShowCourses(prev => {
      const willShow = !prev[akademisyenId];
      if (willShow && !assignedCourses[akademisyenId]) {
        fetchAssignedCourses(akademisyenId);
      }
      return { ...prev, [akademisyenId]: willShow };
    });
  };

  const handleDeactivateAkademisyen = async (akademisyenId, akademisyenName) => {
    if (window.confirm(`${akademisyenName} adlı akademisyeni pasifleştirmek istediğinizden emin misiniz? Bu işlem sonucunda akademisyene bilgilendirme e-postası gönderilecektir.`)) {
      try {
        const response = await axios.post(API_ENDPOINTS.AKADEMISYEN_DEACTIVATE(akademisyenId));
        if (response.data.success) {
          alert(response.data.message);
          loadAkademisyenler(); // Listeyi yenile
        } else {
          alert('Akademisyen pasifleştirilirken hata oluştu: ' + response.data.error);
        }
      } catch (error) {
        alert('Akademisyen pasifleştirilirken hata oluştu: ' + (error.response?.data?.error || error.message));
      }
    }
  };

  const handleActivateAkademisyen = async (akademisyenId, akademisyenName) => {
    if (window.confirm(`${akademisyenName} adlı akademisyeni aktifleştirmek istediğinizden emin misiniz?`)) {
      try {
        const response = await axios.post(API_ENDPOINTS.AKADEMISYEN_ACTIVATE(akademisyenId));
        if (response.data.success) {
          alert(response.data.message);
          loadAkademisyenler(); // Listeyi yenile
        } else {
          alert('Akademisyen aktifleştirilirken hata oluştu: ' + response.data.error);
        }
      } catch (error) {
        alert('Akademisyen aktifleştirilirken hata oluştu: ' + (error.response?.data?.error || error.message));
      }
    }
  };

  // Tek akademisyen ekleme fonksiyonları
  const handleSingleInputChange = (field, value) => {
    setSingleAkademisyen(prev => ({
      ...prev,
      [field]: value
    }));
    setSingleAddResult(null);
    
    // E-posta alanı için otomatik tamamlama önerisi
    if (field === 'email') {
      if (value.includes('@') && !value.includes('@kocaelisaglik.edu.tr')) {
        setShowEmailSuggestion(true);
      } else {
        setShowEmailSuggestion(false);
      }
    }
  };

  const handleEmailSuggestionClick = () => {
    const emailValue = singleAkademisyen.email;
    const atIndex = emailValue.indexOf('@');
    
    if (atIndex !== -1) {
      // "@" işaretinden önceki kısmı al ve "@kocaelisaglik.edu.tr" ekle
      const emailPrefix = emailValue.substring(0, atIndex + 1);
      const fullEmail = emailPrefix + 'kocaelisaglik.edu.tr';
      
      setSingleAkademisyen(prev => ({
        ...prev,
        email: fullEmail
      }));
      setShowEmailSuggestion(false);
    }
  };

  const handleSingleAkademisyenAdd = async () => {
    // Form validasyonu
    if (!singleAkademisyen.academician.trim()) {
      setSingleAddResult({
        success: false,
        error: 'Akademisyen adı zorunludur.'
      });
      return;
    }

    setIsAddingSingle(true);
    setSingleAddResult(null);

    // Fakülte ve program isimlerini bul
    const selectedFaculty = faculties.find(f => f.id === parseInt(singleAkademisyen.facultyId));
    const selectedProgram = singlePrograms.find(p => p.id === parseInt(singleAkademisyen.programId));

    try {
      const response = await axios.post(`${API_BASE_URL}/api/akademisyen/add-single`, {
        academician: singleAkademisyen.academician,
        staff_status: singleAkademisyen.staff_status,
        faculty: selectedFaculty ? selectedFaculty.name : '',
        program: selectedProgram ? selectedProgram.name : '',
        email: singleAkademisyen.email
      });

      if (response.data.success) {
        setSingleAddResult({
          success: true,
          message: 'Akademisyen başarıyla eklendi!',
          data: response.data.data
        });
        
        // Formu temizle
        setSingleAkademisyen({
          title: '',
          name: '',
          surname: '',
          faculty: '',
          program: ''
        });
        
        // Listeyi yenile
        loadAkademisyenler();
      } else {
        setSingleAddResult({
          success: false,
          error: response.data.error || 'Akademisyen eklenirken hata oluştu.'
        });
      }
    } catch (error) {
      setSingleAddResult({
        success: false,
        error: error.response?.data?.error || 'Sunucuya bağlanırken hata oluştu.'
      });
    } finally {
      setIsAddingSingle(false);
    }
  };

  const resetSingleForm = () => {
    setSingleAkademisyen({
      academician: '',
      staff_status: '',
      facultyId: '',
      programId: '',
      email: ''
    });
    setSinglePrograms([]);
    setSingleAddResult(null);
  };

  // Tek akademisyen formu için fakülte seçildiğinde programları yükle
  const handleSingleFacultyChange = async (facultyId) => {
    setSingleAkademisyen(prev => ({
      ...prev,
      facultyId: facultyId,
      programId: '' // Fakülte değiştiğinde programı sıfırla
    }));
    
    if (facultyId) {
      try {
        const response = await axios.get(`${API_ENDPOINTS.PROGRAMS}?facultyId=${facultyId}`);
        setSinglePrograms(response.data || []);
      } catch (error) {
        console.error('Programlar yüklenirken hata:', error);
        setSinglePrograms([]);
      }
    } else {
      setSinglePrograms([]);
    }
  };

  const filteredActiveAkademisyenler = activeAkademisyenler.filter(ak => {
    const q = search.toLowerCase();
    return (
      ak.academician?.toLowerCase().includes(q) ||
      ak.email?.toLowerCase().includes(q) ||
      ak.faculty?.toLowerCase().includes(q) ||
      ak.program?.toLowerCase().includes(q)
    );
  });

  const filteredInactiveAkademisyenler = inactiveAkademisyenler.filter(ak => {
    const q = search.toLowerCase();
    return (
      ak.academician?.toLowerCase().includes(q) ||
      ak.email?.toLowerCase().includes(q) ||
      ak.faculty?.toLowerCase().includes(q) ||
      ak.program?.toLowerCase().includes(q)
    );
  });

  return (
    <div className="akademisyen-tanimla-container">
      <h2 style={{textAlign:'center',marginBottom:24, color:'#294063'}}>Akademisyen Toplu Ekle</h2>

      <div className={"collapsible-card " + (showAkademisyenEkle ? '' : 'collapsed')} style={{marginBottom: 16}}>
        <div className="collapsible-header">
          <h3 className="collapsible-title">Akademisyen Kayıt İşlemleri</h3>
          <button
            type="button"
            className="collapsible-toggle"
            onClick={() => setShowAkademisyenEkle(!showAkademisyenEkle)}
          >
            {showAkademisyenEkle ? 'Gizle' : 'Göster'}
          </button>
        </div>
        {showAkademisyenEkle && (
        <div className="collapsible-body" style={{display:'grid', gap:'12px'}}>
          {/* Excel ile ekle */}
          <div className={"collapsible-card " + (showExcelSection ? '' : 'collapsed')}>
            <div className="collapsible-header">
              <h4 className="collapsible-title" style={{fontSize: '16px'}}>Toplu Akademisyen Kaydı</h4>
              <button
                type="button"
                className="collapsible-toggle"
                onClick={() => setShowExcelSection(!showExcelSection)}
              >
                {showExcelSection ? 'Gizle' : 'Göster'}
              </button>
            </div>
            {showExcelSection && (
            <div className="collapsible-body">
            <p style={{color: '#6b7280', fontSize: 14, marginBottom: 16}}>
              Beklenen başlıklar: Ünvanı, Adı, Soyadı, TC Kimlik No, Kadro Durumu, 
              Birimi, Alt Birimi ve Email. Sütun sırası önemli değildir. TC Kimlik No 
              sisteme kaydedilmez. Email boş veya geçersizse ad-soyaddan kurumsal adres oluşturulur.
              <br/>
              <strong style={{color: '#059669'}}>Yıllık liste:</strong> Aynı email adresine sahip kişilerin hesabı korunur ve seçili yıl profili güncellenir; 
              yeni kişiler için hesap açılır. Dosyada bulunmayan kişiler yalnızca seçili akademik yılda pasifleşir. Geçmiş yıl kayıtları ve kullanıcı hesapları silinmez.
            </p>
            
            <button 
              onClick={downloadTemplate} 
              className="akademisyen-btn btn-green"
              style={{marginBottom: 16}}
            >
              Excel Şablonu İndir
            </button>
            <div className="framed-upload">
              <div
                className={"upload-area" + (isDragOver ? " drag-over" : "")}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => document.getElementById('fileInput').click()}
              >
                <input
                  id="fileInput"
                  type="file"
                  accept=".xlsx,.xls,.csv"
                  onChange={handleFileSelect}
                  style={{display: 'none'}}
                />
                
                {selectedFile ? (
                  <div>
                    <p style={{color: '#059669', fontWeight: 600}}>✓ Dosya seçildi</p>
                    <p style={{color: '#374151'}}>{selectedFile.name}</p>
                  </div>
                ) : (
                  <div>
                    <p style={{color: '#6b7280', marginBottom: 8}}>
                      Dosyayı buraya sürükleyin veya tıklayarak seçin
                    </p>
                    <p style={{color: '#9ca3af', fontSize: 12}}>
                      .xlsx, .xls ve .csv dosyaları kabul edilir
                    </p>
                  </div>
                )}
              </div>
            </div>

            {selectedFile && (
              <button 
                onClick={handleUpload} 
                disabled={isUploading}
                className="akademisyen-btn btn-blue"
              >
                {isUploading ? 'Yükleniyor...' : 'Excel Yükle'}
              </button>
            )}

            {uploadResult && (
              <div className={uploadResult.success ? 'akademisyen-success' : 'akademisyen-error'}>
                {uploadResult.success ? (
                  <div>
                    <h4 style={{margin: '0 0 8px 0'}}>✓ {uploadResult.update_mode ? 'Güncelleme/Ekleme' : 'Yükleme'} Başarılı!</h4>
                    {uploadResult.academic_year && (
                      <p style={{margin: '0 0 4px 0'}}>Akademik Yıl: {uploadResult.academic_year}</p>
                    )}
                    <p style={{margin: '0 0 4px 0'}}>Toplam: {uploadResult.total_rows} satır işlendi</p>
                    <p style={{margin: '0 0 4px 0'}}>Başarılı: {uploadResult.success_count} kayıt</p>
                    <p style={{margin: '0 0 4px 0'}}>Seçili Yılda Aktif: {uploadResult.active_profile_count} akademisyen</p>
                    <p style={{margin: '0 0 4px 0'}}>Seçili Yılda Pasif: {uploadResult.inactive_profile_count} akademisyen</p>
                    {(uploadResult.removed_course_assignments > 0 || uploadResult.removed_content_permissions > 0) && (
                      <p style={{margin: '0 0 4px 0', color: '#92400e'}}>
                        Yıl listesinde bulunmayan kişilerden kaldırılan ders ataması: {uploadResult.removed_course_assignments || 0},
                        içerik izni: {uploadResult.removed_content_permissions || 0}
                      </p>
                    )}
                    {uploadResult.update_mode && (
                      <>
                        <p style={{margin: '0 0 4px 0'}}>Yeni Eklenen: {uploadResult.add_count} kayıt</p>
                        <p style={{margin: '0 0 4px 0'}}>Güncellenen: {uploadResult.update_count} kayıt</p>
                      </>
                    )}
                    <p style={{margin: '0 0 4px 0'}}>Hatalı: {uploadResult.error_count} kayıt</p>
                    <p style={{margin: 0}}>Uyarı: {uploadResult.warning_count || 0} kayıt</p>
                  </div>
                ) : (
                  <div>
                    <h4 style={{margin: '0 0 8px 0'}}>✗ İşlem Hatası</h4>
                    <p style={{margin: 0}}>{uploadResult.error}</p>
                  </div>
                )}
              </div>
            )}

            {uploadResult && uploadResult.results && uploadResult.results.length > 0 && (
              <div style={{marginTop: 16}}>
                <h4 style={{color: '#374151', marginBottom: 8}}>İşlem Sonuçları</h4>
                <div style={{maxHeight: 240, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12}}>
                  {uploadResult.results.map((result, index) => (
                    <div key={index} style={{
                      padding: '8px 0',
                      borderBottom: index < uploadResult.results.length - 1 ? '1px solid #f3f4f6' : 'none',
                      color: result.status === 'error' ? '#dc2626' : result.status === 'warning' ? '#b45309' : '#059669'
                    }}>
                      <strong>Satır {result.row}:</strong> {result.message || result.error}
                      {result.action && (
                        <span style={{
                          marginLeft: '8px',
                          padding: '2px 6px',
                          borderRadius: '4px',
                          fontSize: '12px',
                          background: result.action === 'updated' ? '#e0f2fe' : '#e8f5e8',
                          color: result.action === 'updated' ? '#0277bd' : '#2e7d32'
                        }}>
                          {result.action === 'updated' ? 'GÜNCELLENDİ' : 'EKLENDİ'}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            </div>
            )}
          </div>

          {/* Tek Akademisyen Ekle */}
          <div className={"collapsible-card " + (showSingleForm ? '' : 'collapsed')} style={{marginTop: 4}}>
            <div className="collapsible-header">
              <h4 className="collapsible-title" style={{fontSize:'16px'}}>Yeni Akademisyen Kaydı</h4>
              <button
                onClick={() => setShowSingleForm(!showSingleForm)}
                className={`collapsible-toggle ${showSingleForm ? 'active' : ''}`}
              >
                {showSingleForm ? 'Gizle' : 'Göster'}
              </button>
            </div>

            {showSingleForm && (
              <div className="single-akademisyen-form">
                <div className="single-form-grid">
                  <div className="single-form-field">
                    <label className="single-form-label">
                      Akademisyen <span className="single-form-required">*</span>
                    </label>
                    <input
                      type="text"
                      value={singleAkademisyen.academician}
                      onChange={(e) => handleSingleInputChange('academician', e.target.value)}
                      placeholder="Örn: Prof.Dr. Ahmet Yılmaz"
                      className="single-form-input"
                      required
                    />
                  </div>

              <div className="single-form-field">
                <label className="single-form-label">
                  Kadro Durumu
                </label>
                <select
                  value={singleAkademisyen.staff_status}
                  onChange={(e) => handleSingleInputChange('staff_status', e.target.value)}
                  className="single-form-input"
                >
                  <option value="">Seçiniz</option>
                  <option value="Üniversite Kadrosunda">Üniversite Kadrosunda</option>
                  <option value="Kadro Dışında">Kadro Dışında</option>
                </select>
              </div>

              <div className="single-form-field" style={{position: 'relative'}}>
                <label className="single-form-label">
                  E-posta
                </label>
                <input
                  type="email"
                  value={singleAkademisyen.email}
                  onChange={(e) => handleSingleInputChange('email', e.target.value)}
                  onBlur={() => setTimeout(() => setShowEmailSuggestion(false), 200)}
                  placeholder="Boş bırakılırsa otomatik oluşturulur"
                  className="single-form-input"
                />
                {showEmailSuggestion && (
                  <div 
                    className="email-suggestion"
                    onClick={handleEmailSuggestionClick}
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      backgroundColor: '#ffffff',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      marginTop: '4px',
                      padding: '8px 12px',
                      cursor: 'pointer',
                      zIndex: 1000,
                      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                      fontSize: '14px',
                      color: '#0369a1',
                      fontWeight: 500
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f9ff'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#ffffff'}
                  >
                    {singleAkademisyen.email.split('@')[0]}@kocaelisaglik.edu.tr
                  </div>
                )}
              </div>

              <div className="single-form-field">
                <label className="single-form-label">
                  Fakülte
                </label>
                <select
                  value={singleAkademisyen.facultyId}
                  onChange={(e) => handleSingleFacultyChange(e.target.value)}
                  className="single-form-input"
                >
                  <option value="">Fakülte Seçiniz</option>
                  {faculties.map(f => (
                    <option key={f.id} value={f.id}>{f.name}</option>
                  ))}
                </select>
              </div>

              <div className="single-form-field">
                <label className="single-form-label">
                  Program
                </label>
                <select
                  value={singleAkademisyen.programId}
                  onChange={(e) => handleSingleInputChange('programId', e.target.value)}
                  className="single-form-input"
                  disabled={!singleAkademisyen.facultyId}
                >
                  <option value="">Program Seçiniz</option>
                  {singlePrograms.map(p => (
                    <option key={p.id} value={p.id}>{p.name}</option>
                  ))}
                </select>
              </div>
            </div>

            {singleAddResult && (
              <div className={singleAddResult.success ? 'akademisyen-success' : 'akademisyen-error'}>
                {singleAddResult.success ? (
                  <div>
                    <h4 style={{margin: '0 0 8px 0'}}>✓ Ekleme Başarılı!</h4>
                    <p style={{margin: '0 0 4px 0'}}>Akademisyen: {singleAddResult.data?.academician || singleAddResult.data?.academisyen}</p>
                    <p style={{margin: '0 0 4px 0'}}>E-posta: {singleAddResult.data?.email}</p>
                    <p style={{margin: 0}}>Şifre: {singleAddResult.data?.password}</p>
                  </div>
                ) : (
                  <div>
                    <h4 style={{margin: '0 0 8px 0'}}>✗ Ekleme Hatası</h4>
                    <p style={{margin: 0}}>{singleAddResult.error}</p>
                  </div>
                )}
              </div>
            )}

            <div className="single-form-buttons">
              <button 
                onClick={handleSingleAkademisyenAdd}
                disabled={isAddingSingle}
                className="akademisyen-btn btn-green no-margin-top"
              >
                {isAddingSingle ? 'Ekleniyor...' : 'Akademisyen Ekle'}
              </button>

              <button 
                onClick={resetSingleForm}
                disabled={isAddingSingle}
                className="akademisyen-btn btn-gray no-margin-top"
              >
                Formu Temizle
              </button>
            </div>

            <p className="single-form-note">
              <strong>Not:</strong> E-posta adresi ve şifre otomatik olarak oluşturulacaktır. 
              E-posta: ad.soyad@kocaelisaglik.edu.tr formatında, şifre: İsimSoyisim12345 formatında olacaktır (ilk karakter büyük, sonraki karakterler küçük).
            </p>
          </div>
        )}
      </div>

      </div>
      )}
      </div>

      <div style={{marginTop: 32}}>
        {/* Yetkiler - Tek kart içinde iki toggle */}
        <div style={{ 
          marginBottom: '20px', 
          padding: '15px', 
          backgroundColor: '#fff', 
          borderRadius: '12px',
          border: '2px solid #023b58',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
        }}>
          <h4 style={{ margin: '0 0 15px 0', color: '#023b58', fontWeight: 700 }}>Yetkiler</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '14px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
              <label style={{ display: 'inline-flex', alignItems: 'center', cursor: bulkPermissionLoading ? 'not-allowed' : 'pointer' }}>
                <div 
                  onClick={handleToggleBulkSyllabusPermission}
                  style={{
                    position: 'relative',
                    width: '64px',
                    height: '32px',
                    borderRadius: '16px',
                    background: allActiveHaveSyllabusPermission ? '#22c55e' : '#d1d5db',
                    transition: 'background 0.2s ease',
                    opacity: bulkPermissionLoading ? 0.7 : 1,
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '4px',
                      left: allActiveHaveSyllabusPermission ? '34px' : '4px',
                      width: '24px',
                      height: '24px',
                      borderRadius: '12px',
                      background: '#ffffff',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                      transition: 'left 0.2s ease'
                    }}
                  />
                </div>
                <input
                  type="checkbox"
                  checked={allActiveHaveSyllabusPermission}
                  onChange={handleToggleBulkSyllabusPermission}
                  disabled={bulkPermissionLoading}
                  style={{ display: 'none' }}
                />
              </label>
              <div style={{ minWidth: '200px', color: '#374151', fontWeight: 600 }}>
                {allActiveHaveSyllabusPermission ? 'Toplu İzlence Erişimi Aktif' : 'Toplu İzlence Erişimi Kapalı'}
              </div>
              {bulkPermissionLoading && <span style={{ color: '#6b7280' }}>İşleniyor...</span>}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
              <label style={{ display: 'inline-flex', alignItems: 'center', cursor: pretestLoading ? 'not-allowed' : 'pointer' }}>
                <div
                  onClick={handleTogglePretestPermission}
                  style={{
                    position: 'relative',
                    width: '64px',
                    height: '32px',
                    borderRadius: '16px',
                    background: pretestEnabled ? '#22c55e' : '#d1d5db',
                    transition: 'background 0.2s ease',
                    opacity: pretestLoading ? 0.7 : 1,
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '4px',
                      left: pretestEnabled ? '34px' : '4px',
                      width: '24px',
                      height: '24px',
                      borderRadius: '12px',
                      background: '#ffffff',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                      transition: 'left 0.2s ease'
                    }}
                  />
                </div>
                <input
                  type="checkbox"
                  checked={pretestEnabled}
                  onChange={handleTogglePretestPermission}
                  disabled={pretestLoading}
                  style={{ display: 'none' }}
                />
              </label>
              <div style={{ minWidth: '200px', color: '#374151', fontWeight: 600 }}>
                {pretestEnabled ? 'Öntest Modülü Aktif' : 'Öntest Modülü Kapalı'}
              </div>
              {pretestLoading && <span style={{ color: '#6b7280' }}>İşleniyor...</span>}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
              <label style={{ display: 'inline-flex', alignItems: 'center', cursor: learningOutcomesEditLoading ? 'not-allowed' : 'pointer' }}>
                <div
                  onClick={handleToggleLearningOutcomesEditPermission}
                  style={{
                    position: 'relative',
                    width: '64px',
                    height: '32px',
                    borderRadius: '16px',
                    background: learningOutcomesEditEnabled ? '#22c55e' : '#d1d5db',
                    transition: 'background 0.2s ease',
                    opacity: learningOutcomesEditLoading ? 0.7 : 1,
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '4px',
                      left: learningOutcomesEditEnabled ? '34px' : '4px',
                      width: '24px',
                      height: '24px',
                      borderRadius: '12px',
                      background: '#ffffff',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                      transition: 'left 0.2s ease'
                    }}
                  />
                </div>
                <input
                  type="checkbox"
                  checked={learningOutcomesEditEnabled}
                  onChange={handleToggleLearningOutcomesEditPermission}
                  disabled={learningOutcomesEditLoading}
                  style={{ display: 'none' }}
                />
              </label>
              <div style={{ minWidth: '250px', color: '#374151', fontWeight: 600 }}>
                {learningOutcomesEditEnabled ? 'Öğrenme Çıktıları Düzenleme Aktif' : 'Öğrenme Çıktıları Düzenleme Kapalı'}
              </div>
              {learningOutcomesEditLoading && <span style={{ color: '#6b7280' }}>İşleniyor...</span>}
            </div>

            {/* İzlence Yükleme Yetkisi */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <label style={{ display: 'inline-flex', alignItems: 'center', cursor: syllabusUploadLoading ? 'not-allowed' : 'pointer' }}>
                <div
                  onClick={handleToggleSyllabusUploadPermission}
                  style={{
                    position: 'relative',
                    width: '64px',
                    height: '32px',
                    borderRadius: '16px',
                    background: syllabusUploadEnabled ? '#22c55e' : '#d1d5db',
                    transition: 'background 0.2s ease',
                    opacity: syllabusUploadLoading ? 0.7 : 1,
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      top: '4px',
                      left: syllabusUploadEnabled ? '34px' : '4px',
                      width: '24px',
                      height: '24px',
                      borderRadius: '12px',
                      background: '#ffffff',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                      transition: 'left 0.2s ease'
                    }}
                  />
                </div>
                <input
                  type="checkbox"
                  checked={syllabusUploadEnabled}
                  onChange={handleToggleSyllabusUploadPermission}
                  disabled={syllabusUploadLoading}
                  style={{ display: 'none' }}
                />
              </label>
              <div style={{ minWidth: '250px', color: '#374151', fontWeight: 600 }}>
                {syllabusUploadEnabled ? 'İzlence Yükleme Aktif' : 'İzlence Yükleme Kapalı'}
              </div>
              {syllabusUploadLoading && <span style={{ color: '#6b7280' }}>İşleniyor...</span>}
            </div>
          </div>
        </div>

        <div style={{display:'flex', gap:'16px', flexWrap:'wrap'}}>
          {/* Aktif akademisyenler kartı */}
          <div style={{
            flex:'1 1 540px',
            background:'#fff',
            border:'2px solid #023b58',
            borderRadius:'12px',
            boxShadow:'0 2px 10px rgba(0,0,0,0.07)',
            padding:'16px'
          }}>
            <div className="akademisyen-table-header" style={{marginBottom:12}}>
              <h3 className="akademisyen-table-title">Aktif Akademisyenler</h3>
              <div className="akademisyen-table-stats">
                <span>Toplam: <span className="count">{activeAkademisyenler.length}</span></span>
                <span>Listelenen: <span className="count">{filteredActiveAkademisyenler.length}</span></span>
              </div>
            </div>
            
            <input
              type="text"
              placeholder="İsim, soyisim, e-posta, unvan, fakülte, program ara..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="akademisyen-search"
              style={{marginBottom:12}}
            />

            <div className="akademisyen-table-container">
              <table className="akademisyen-table">
            <thead>
              <tr>
                 <th>Ders Ata</th>
                 <th>ID</th>
                 <th>Akademisyen</th>
                 <th>E-posta</th>
                 <th>Fakülte</th>
                 <th>Program</th>
                 <th>İzlence Yetkisi</th>
                 <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {filteredActiveAkademisyenler.map((ak, idx) => (
                <React.Fragment key={ak.id}>
                  <tr 
                    style={{cursor: 'pointer'}} 
                    onClick={() => handleShowCourses(ak.id)}
                    title="Atanan dersleri görmek için tıklayın"
                  >
                     <td>
                       <button 
                         className="akademisyen-btn" 
                         onClick={(e) => {
                           e.stopPropagation();
                           handleShowAssign(ak.id);
                         }}
                       >
                         {showAssignCourse[ak.id] ? 'Gizle' : 'Ders Ata'}
                       </button>
                     </td>
                     <td>{ak.id}</td>
                     <td>{ak.academician || '-'}</td>
                     <td>
                       <div style={{display: 'flex', flexDirection: 'column', lineHeight: '1.1', gap: '2px'}}>
                         <span style={{fontWeight: '600', color: '#000000', fontSize: '14px', wordBreak: 'break-all'}}>
                           {ak.email.split('@')[0]}
                         </span>
                         <span style={{fontSize: '14px', color: '#000000', fontWeight: '500', wordBreak: 'break-all'}}>
                           @{ak.email.split('@')[1]}
                         </span>
                       </div>
                     </td>
                     <td>{ak.faculty || '-'}</td>
                     <td>{ak.program || '-'}</td>
                     <td>
                      <input
                        type="checkbox"
                        checked={!!ak.syllabus_permission}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleYetkiChange(ak.id, !!ak.syllabus_permission);
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </td>
                    <td>
                      <button 
                        className="akademisyen-btn" 
                        style={{background: '#dc3545', fontSize: '12px', padding: '8px 12px'}}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeactivateAkademisyen(ak.id, ak.academician || 'Akademisyen');
                        }}
                        title="Akademisyeni pasifleştir"
                      >
                        Pasifleştir
                      </button>
                    </td>
                  </tr>
                  {showCourses[ak.id] && (
                    <tr>
                      <td colSpan="8" style={{background:'#f0f9ff',padding:'16px',borderBottom:'1px solid #e5e7eb'}}>
                        <div style={{marginBottom:8}}>
                          <strong style={{color:'#0369a1',fontSize:14,display:'flex',alignItems:'center',gap:8}}>
                            📚 Atanan Dersler ({assignedCourses[ak.id]?.length || 0})
                          </strong>
                        </div>
                        {assignedCourses[ak.id] && assignedCourses[ak.id].length > 0 ? (
                          <>
                            {/* Desktop Tablo Görünümü */}
                            <div className="assigned-courses-table" style={{background:'#ffffff',borderRadius:8,border:'1px solid #e0f2fe',overflow:'hidden'}}>
                              <table style={{width:'100%',borderCollapse:'collapse'}}>
                                <thead>
                                  <tr style={{background:'linear-gradient(135deg, #0369a1 0%, #1e40af 100%)'}}>
                                    <th style={{padding:'12px 8px',color:'#ffffff',textAlign:'center',fontSize:12,fontWeight:600,borderBottom:'1px solid #1e40af',width:'20px'}}>
                                      #
                                    </th>
                                    <th style={{padding:'12px 16px',color:'#ffffff',textAlign:'left',fontSize:13,fontWeight:600,borderBottom:'1px solid #1e40af'}}>
                                      Ders Adı
                                    </th>
                                    <th style={{padding:'12px 16px',color:'#ffffff',textAlign:'left',fontSize:13,fontWeight:600,borderBottom:'1px solid #1e40af'}}>
                                      Fakülte
                                    </th>
                                    <th style={{padding:'12px 16px',color:'#ffffff',textAlign:'left',fontSize:13,fontWeight:600,borderBottom:'1px solid #1e40af'}}>
                                      Program
                                    </th>
                                    <th style={{padding:'12px 16px',color:'#ffffff',textAlign:'center',fontSize:13,fontWeight:600,borderBottom:'1px solid #1e40af',width:'80px'}}>
                                      İşlem
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {assignedCourses[ak.id].map((course,i)=>(
                                    <tr key={i} style={{
                                      borderBottom: i < assignedCourses[ak.id].length - 1 ? '1px solid #f1f5f9' : 'none',
                                      background: i % 2 === 0 ? '#ffffff' : '#f8fafc'
                                    }}>
                                      <td style={{padding:'10px 8px',fontSize:12,color:'#6b7280',fontWeight:600,fontFamily:'monospace',textAlign:'center'}}>
                                        {i + 1}
                                      </td>
                                      <td style={{padding:'10px 16px',fontSize:13,color:'#0369a1',fontWeight:600}}>
                                        {course.courseName}
                                      </td>
                                      <td style={{padding:'10px 16px',fontSize:13,color:'#374151'}}>
                                        {course.facultyName}
                                      </td>
                                      <td style={{padding:'10px 16px',fontSize:13,color:'#374151'}}>
                                        {course.programName}
                                      </td>
                                      <td style={{padding:'10px 16px',textAlign:'center'}}>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleRemoveCourse(ak.id, course.assignmentId, course.courseName);
                                          }}
                                          style={{
                                            background: '#dc2626',
                                            color: '#ffffff',
                                            border: 'none',
                                            borderRadius: '4px',
                                            padding: '4px 8px',
                                            fontSize: '11px',
                                            fontWeight: '500',
                                            cursor: 'pointer',
                                            transition: 'background 0.2s'
                                          }}
                                          onMouseOver={(e) => e.target.style.background = '#b91c1c'}
                                          onMouseOut={(e) => e.target.style.background = '#dc2626'}
                                          title={`${course.courseName} dersini kaldır`}
                                        >
                                          ✕
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            
                            {/* Mobile Liste Görünümü */}
                            <div className="assigned-courses-list" style={{display:'none'}}>
                              {assignedCourses[ak.id].map((course,i)=>(
                                <div key={i} style={{
                                  background: i % 2 === 0 ? '#ffffff' : '#f8fafc',
                                  border:'1px solid #e0f2fe',
                                  borderRadius:8,
                                  padding:'12px 16px',
                                  marginBottom:8,
                                  boxShadow:'0 1px 3px rgba(0,0,0,0.05)',
                                  position:'relative'
                                }}>
                                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:8}}>
                                    <div style={{display:'flex',alignItems:'center'}}>
                                      <span style={{
                                        background:'linear-gradient(135deg, #0369a1 0%, #1e40af 100%)',
                                        color:'#ffffff',
                                        padding:'4px 8px',
                                        borderRadius:4,
                                        fontSize:12,
                                        fontWeight:600,
                                        marginRight:8,
                                        minWidth:24,
                                        textAlign:'center'
                                      }}>
                                        {i + 1}
                                      </span>
                                      <span style={{fontSize:14,color:'#0369a1',fontWeight:600}}>
                                        {course.courseName}
                                      </span>
                                    </div>
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleRemoveCourse(ak.id, course.assignmentId, course.courseName);
                                      }}
                                      style={{
                                        background: '#dc2626',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '4px',
                                        padding: '4px 8px',
                                        fontSize: '11px',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                        transition: 'background 0.2s'
                                      }}
                                      onMouseOver={(e) => e.target.style.background = '#b91c1c'}
                                      onMouseOut={(e) => e.target.style.background = '#dc2626'}
                                      title={`${course.courseName} dersini kaldır`}
                                    >
                                      ✕
                                    </button>
                                  </div>
                                  <div style={{display:'flex',flexDirection:'column',gap:4,paddingLeft:32}}>
                                    <div style={{fontSize:12,color:'#374151'}}>
                                      <strong style={{color:'#6b7280'}}>Fakülte:</strong> {course.facultyName}
                                    </div>
                                    <div style={{fontSize:12,color:'#374151'}}>
                                      <strong style={{color:'#6b7280'}}>Program:</strong> {course.programName}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <div style={{
                            textAlign:'center',
                            padding:'20px',
                            color:'#6b7280',
                            fontStyle:'italic',
                            background:'#f9fafb',
                            borderRadius:8,
                            border:'1px dashed #d1d5db'
                          }}>
                            Bu akademisyene henüz ders atanmamış.
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                  {showAssignCourse[ak.id] && (
                    <tr>
                      <td colSpan="9" style={{background:'#f8fafc',padding:'16px',borderBottom:'1px solid #e5e7eb'}}>
                        <div style={{display:'flex',gap:12,alignItems:'center',flexWrap:'wrap',marginBottom:12}}>
                          <select
                            value={selectedAssign[ak.id]?.educationTypeId || ''}
                            onChange={e=>handleAssignChange(ak.id,'educationTypeId',e.target.value)}
                            style={{padding:'8px 12px',borderRadius:8,border:'1px solid #d1d5db',fontSize:14}}>
                            <option value=''>Eğitim Türü Seç</option>
                            {educationTypes.map(et=>(<option key={et.id} value={et.id}>{et.name}</option>))}
                          </select>
                          <select
                            value={selectedAssign[ak.id]?.facultyId || ''}
                            onChange={e=>handleAssignChange(ak.id,'facultyId',e.target.value)}
                            style={{padding:'8px 12px',borderRadius:8,border:'1px solid #d1d5db',fontSize:14}}>
                            <option value=''>Fakülte Seç</option>
                            {faculties.map(f=>(<option key={f.id} value={f.id}>{f.name}</option>))}
                          </select>
                          <select
                            value={selectedAssign[ak.id]?.programId || ''}
                            onChange={e=>handleAssignChange(ak.id,'programId',e.target.value)}
                            style={{padding:'8px 12px',borderRadius:8,border:'1px solid #d1d5db',fontSize:14}}
                            disabled={!selectedAssign[ak.id]?.facultyId}
                          >
                            <option value=''>Program Seç</option>
                            {(programs[selectedAssign[ak.id]?.facultyId]||[]).map(p=>(<option key={p.id} value={p.id}>{p.name}</option>))}
                          </select>
                          <select
                            value={selectedAssign[ak.id]?.courseId || ''}
                            onChange={e=>handleAssignChange(ak.id,'courseId',e.target.value)}
                            style={{padding:'8px 12px',borderRadius:8,border:'1px solid #d1d5db',fontSize:14}}
                            disabled={!selectedAssign[ak.id]?.programId}
                          >
                            <option value=''>Ders Seç</option>
                            {(courses[selectedAssign[ak.id]?.programId]||[]).map(c=>(<option key={c.id} value={c.id}>{c.name}</option>))}
                          </select>
                          <button 
                            className="akademisyen-btn" 
                            onClick={()=>handleAssignCourse(ak.id)}
                            style={{background:'#059669'}}
                          >
                            Ders Ata
                          </button>
                        </div>
                        
                        {/* Seçmeli Ders Grubu Modal */}
                        {showElectiveModal[ak.id] && (
                          <div className="elective-modal-overlay" onClick={() => handleElectiveModalCancel(ak.id)}>
                            <div className="elective-modal-content" onClick={(e) => e.stopPropagation()}>
                              <div className="elective-modal-header">
                                <h3>Alt Dersleri Seçin</h3>
                                <button 
                                  className="elective-modal-close"
                                  onClick={() => handleElectiveModalCancel(ak.id)}
                                >
                                  ×
                                </button>
                              </div>
                              <div className="elective-modal-body">
                                <p style={{marginBottom: '16px', color: '#6b7280', fontSize: '14px'}}>
                                  <strong>{selectedElectiveGroup[ak.id]?.name || selectedElectiveGroup[ak.id]?.course_name}</strong> grubundan alt dersleri seçin:
                                </p>
                                {electiveLessons[ak.id] && electiveLessons[ak.id].length > 0 ? (
                                  <div className="elective-lessons-list">
                                    {electiveLessons[ak.id].map(lesson => {
                                      const isSelected = (selectedElectiveLessons[ak.id] || []).includes(lesson.id);
                                      return (
                                        <label 
                                          key={lesson.id} 
                                          className={`elective-lesson-item ${isSelected ? 'selected' : ''}`}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={() => handleElectiveLessonToggle(ak.id, lesson.id)}
                                          />
                                          <span className="elective-lesson-name">
                                            {lesson.course_name || lesson.name} ({lesson.course_code || lesson.code || 'Kod Yok'})
                                          </span>
                                        </label>
                                      );
                                    })}
                                  </div>
                                ) : (
                                  <p style={{color: '#9ca3af', fontSize: '14px', textAlign: 'center', padding: '20px'}}>
                                    Bu seçmeli ders grubunda alt ders bulunmamaktadır.
                                  </p>
                                )}
                                {selectedElectiveLessons[ak.id] && selectedElectiveLessons[ak.id].length > 0 && (
                                  <p style={{marginTop: '16px', color: '#059669', fontSize: '14px', fontWeight: '600'}}>
                                    {selectedElectiveLessons[ak.id].length} adet ders seçildi
                                  </p>
                                )}
                              </div>
                              <div className="elective-modal-footer">
                                <button 
                                  className="elective-modal-btn elective-modal-btn-cancel"
                                  onClick={() => handleElectiveModalCancel(ak.id)}
                                >
                                  İptal
                                </button>
                                <button 
                                  className="elective-modal-btn elective-modal-btn-confirm"
                                  onClick={() => handleElectiveModalConfirm(ak.id)}
                                  disabled={!selectedElectiveLessons[ak.id] || selectedElectiveLessons[ak.id].length === 0}
                                >
                                  Seç ({selectedElectiveLessons[ak.id]?.length || 0})
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                        
                        {assignedCourses[ak.id] && assignedCourses[ak.id].length > 0 && (
                          <div>
                            <strong style={{color:'#374151',fontSize:14}}>Atanmış Dersler:</strong>
                            <div style={{marginTop:8,display:'flex',flexWrap:'wrap',gap:8}}>
                              {assignedCourses[ak.id].map((d,i)=>(
                                <div key={i} style={{
                                  background:'#e0f2fe',
                                  color:'#0369a1',
                                  padding:'4px 8px',
                                  borderRadius:6,
                                  fontSize:12,
                                  fontWeight:500,
                                  display:'flex',
                                  alignItems:'center',
                                  gap:6
                                }}>
                                  <span>{d.facultyName} - {d.programName} - {d.courseName}</span>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleRemoveCourse(ak.id, d.assignmentId, d.courseName);
                                    }}
                                    style={{
                                      background: '#dc2626',
                                      color: '#ffffff',
                                      border: 'none',
                                      borderRadius: '50%',
                                      width: '16px',
                                      height: '16px',
                                      fontSize: '10px',
                                      fontWeight: '500',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      lineHeight: '1',
                                      transition: 'all 0.2s'
                                    }}
                                    onMouseOver={(e) => e.target.style.background = '#b91c1c'}
                                    onMouseOut={(e) => e.target.style.background = '#dc2626'}
                                    title={`${d.courseName} dersini kaldır`}
                                  >
                                    ✕
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>

          {/* Pasif akademisyenler kartı */}
          <div style={{
            flex:'1 1 540px',
            background:'#fff',
            border:'2px solid #023b58',
            borderRadius:'12px',
            boxShadow:'0 2px 10px rgba(0,0,0,0.07)',
            padding:'16px'
          }}>
            <div className="akademisyen-table-header" style={{marginBottom:12}}>
              <h3 className="akademisyen-table-title" style={{color: '#dc3545'}}>
                Pasif Akademisyenler {!showInactiveSection && `(${inactiveAkademisyenler.length})`}
              </h3>
              <button 
                onClick={() => setShowInactiveSection(!showInactiveSection)}
                className="toggle-form-btn"
                style={{background: showInactiveSection ? '#dc3545' : '#6b7280'}}
              >
                {showInactiveSection ? 'Gizle' : 'Göster'}
              </button>
            </div>

            {showInactiveSection && (
              <>
                <div className="akademisyen-table-stats" style={{marginBottom: 12}}>
                  <span>Toplam: <span className="count">{inactiveAkademisyenler.length}</span></span>
                  <span>Listelenen: <span className="count">{filteredInactiveAkademisyenler.length}</span></span>
                </div>

                {filteredInactiveAkademisyenler.length > 0 ? (
                  <div className="akademisyen-table-container">
                    <table className="akademisyen-table">
                      <thead>
                        <tr style={{background: '#dc3545'}}>
                          <th>ID</th>
                          <th>Akademisyen</th>
                          <th>E-posta</th>
                          <th>Fakülte</th>
                          <th>Program</th>
                          <th>İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredInactiveAkademisyenler.map((ak, idx) => (
                          <tr key={ak.id} style={{backgroundColor: '#fef2f2'}}>
                            <td>{ak.id}</td>
                            <td>{ak.academician || '-'}</td>
                            <td>
                              <div style={{display: 'flex', flexDirection: 'column', lineHeight: '1.1', gap: '2px'}}>
                                <span style={{fontWeight: '600', color: '#dc3545', fontSize: '14px', wordBreak: 'break-all'}}>
                                  {ak.email.split('@')[0]}
                                </span>
                                <span style={{fontSize: '14px', color: '#dc3545', fontWeight: '500', wordBreak: 'break-all'}}>
                                  @{ak.email.split('@')[1]}
                                </span>
                              </div>
                            </td>
                            <td>{ak.faculty || '-'}</td>
                            <td>{ak.program || '-'}</td>
                            <td>
                              <button 
                                className="akademisyen-btn" 
                                style={{background: '#059669', fontSize: '12px', padding: '8px 12px'}}
                                onClick={() => handleActivateAkademisyen(ak.id, ak.academician || 'Akademisyen')}
                                title="Akademisyeni aktifleştir"
                              >
                                Aktifleştir
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div style={{
                    textAlign: 'center',
                    padding: '40px 20px',
                    color: '#059669',
                    background: '#f0f9ff',
                    borderRadius: '8px',
                    border: '2px dashed #d1d5db'
                  }}>
                    <h4 style={{margin: '0 0 8px 0', color: '#059669'}}>🎉 Harika!</h4>
                    <p style={{margin: 0}}>Pasif akademisyen bulunmuyor.</p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AkademisyenTopluEkle;
